(function () {
  function init() {
    var visual = document.querySelector("[data-qr-control-visual]");
    if (!visual || visual.dataset.qrInit || !window.gsap || !window.ScrollTrigger) return;
    visual.dataset.qrInit = "true";

    ScrollTrigger.create({
      trigger: visual,
      start: "top bottom",
      end: "bottom top",
      scrub: 1,
      onUpdate: function (self) {
        gsap.to(visual, { y: self.progress * -50, overwrite: "auto", duration: 0.3 });
      },
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
